<template>
    <div>
        <incident-detail />
    </div>
</template>
<script>
</script>